<script>
// import apiServices from '@/services/yungol-services'
export default {
  template: `
    <div style='width: 100%; height: 100%; margin: auto;'>
      <div v-if='!buttons' class="has-text-centered">
              <span class="icon" style="padding-top: 20px;">
                <span v-tooltip.right="{content: messageR, targetClasses: 'tag is-warning', html: true}">No cumple</span>
              </span>
      </div>
      <div v-if='buttons' class="buttons is-justify-end">
        <router-link
        v-tooltip="'Ver resultados del Líder'"
        :to="{ name: 'resultlider', params: { procesoid: params.data.proceso, liderid: params.data.evaluado._id } }"
        class="button is-dark"
        target="_blank"
        style='margin-top: 5px;'
        >
          <span class="icon">
            <i class="material-icons">visibility</i>
          </span>
        </router-link>
        <button style='margin-top: 5px;' class="button is-link" v-tooltip="'Link y contraseña de la encuesta'" v-on:click="showShare()">
            <span class="icon">
              <i class="material-icons">share</i>
            </span>
        </button>
      </div>
    </div>`,
  data(){
    return {
      params: this.$parent.params,
      buttons: true,
      messageR: "Es necesario al menos la autoevaluación para mostrar resultados",
    }
  },
  beforeMount() {
    if (this.params.data.status !== 'calculado' && this.params.data['cantEncuestasCalculate'] < 3){
      this.buttons = false
    }
  },
  methods:{
    // Actions
    async showShare(){
      const i = this.params.data
      this.$emit('showShare', i)
    }
  }
}
</script>

<style lang='scss'>
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/lideres/components/buttonsActionSummary.vue